/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {LayoutResource} from '../../../components/api/resources/resource/layout.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-layout-route-page',
  template: `
    <adn-layout-list-page
      *ngIf="list"
      [list]="list">
    </adn-layout-list-page>
  `
})
export class LayoutRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(LayoutResource) private readonly Layout: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageLayouts.apiKey)
      && !this.LocalUserPermissions.hasNetwork(PERMISSIONS.axPublisherAdmin.apiKey);

    this.adnListHelper.setUpList(this.list, this.Layout, readOnly, 'fullLayoutList', {
      baseTable: 'layout'
    });
  }
}
